import React from 'react';
import PropTypes from 'prop-types';
import { Col, KeyValue, NoValue, Row } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { getCustomFieldValue } from '../../../../utils/utils';

function CheckboxFieldView({ fieldValues, locale, data }) {
  const { name, label, schema } = fieldValues;
  const fieldLabel = label.find((field) => field.locale === locale)?.value;
  const fieldValue =
    schema === 'default' ? data[name] : getCustomFieldValue(name, data);

  return (
    <Row>
      <Col xs={12}>
        <KeyValue
          label={fieldLabel}
          value={
            fieldValue && fieldValue !== false ? (
              <FormattedMessage
                id={`ui-plugin-inventory-templates.inventoryTemplates.${fieldValue?.toString()}`}
                defaultMessage={fieldValue?.toString()}
              />
            ) : (
              <NoValue />
            )
          }
        />
      </Col>
    </Row>
  );
}

CheckboxFieldView.propTypes = {
  fieldValues: PropTypes.object,
  locale: PropTypes.string,
  data: PropTypes.object,
};

export default CheckboxFieldView;
